import React, { useState, useEffect } from "react";
import {
	ButtonSizeOptions,
	SecondaryButton,
	InputText,
	ButtonText
} from "@loanbossinc/component-library";
import {
	Input,
	MenuItem,
	ListItemText,
	Select,
	Checkbox,
	IconButton
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import "../emailTemplateStyles.css";
import { isEmail } from "helpers";

const ENTER_KEY = 13;

const RecipientRow = ({
	actionWord = "",
	contactInputType,
	setContactInputType,
	selectedContacts,
	setSelectedContacts,
	itemHeight,
	itemPaddingTop,
	contacts,
	emailInput,
	setEmailInput,
	includeCCRecipientToggle = false,
	ccRowIsPresent = true,
	setCcRowIsPresent
}) => {
	const [isEmailInputError, setIsEmailInputError] = useState(false);
	const [emailInputClass, setEmailInputClass] = useState("email-template-email-input");
	const [ccRowInclusionText, setCcRowInclusionText] = useState("Remove CC recipients");

	useEffect(() => {
		if (ccRowIsPresent) {
			setCcRowInclusionText("Remove CC recipients");
		} else {
			setCcRowInclusionText("Add CC recipients");
		}
	}, [ccRowIsPresent]);

	useEffect(() => {
		if (isEmailInputError) {
			setEmailInputClass("email-template-email-input-error");
			setTimeout(() => {
				setIsEmailInputError(false);
			}, 500);
		}

		if (!isEmailInputError) {
			setEmailInputClass("email-template-email-input");
		}
	}, [isEmailInputError]);

	const handleAddEmailButtonClick = () => {
		if (!emailInput || !isEmail(emailInput)) {
			setIsEmailInputError(true);
		}

		if (emailInput && isEmail(emailInput)) {
			addEmail(emailInput);
		}
	};

	const handleAddEmailEnterPress = e => {
		if (e.charCode === ENTER_KEY && (!e.target.value || !isEmail(e.target.value))) {
			setIsEmailInputError(true);
		}

		if (e.charCode === ENTER_KEY && Boolean(e.target.value) && isEmail(e.target.value)) {
			addEmail(e.target.value);
		}
	};

	const addEmail = emailInput => {
		setSelectedContacts([
			...selectedContacts,
			{
				name: "",
				email: emailInput
			}
		]);
		setEmailInput("");
	};

	return (
		<div className="email-template-recipients">
			<div>{actionWord}</div>
			{
				!contactInputType &&
				<div className="email-template-recipient-chips-and-inclusion-wrapper">
					<div className="email-template-recipient-chips-wrapper">
						<SecondaryButton
							label="Select contacts"
							size={ButtonSizeOptions.smFluid}
							style={{ width: "fit-content" }}
							onClick={() => setContactInputType("select")}
						/>
						<span className="or-label">OR</span>
						<SecondaryButton
							label="Type Email"
							size={ButtonSizeOptions.smFluid}
							style={{ width: "fit-content" }}
							onClick={() => setContactInputType("input")}
						/>
					</div>
					{includeCCRecipientToggle &&
						<div>
							<ButtonText
								label={ccRowInclusionText}
								className="email-template-add-email-buttontext-cc-inclusion"
								onClick={() => setCcRowIsPresent(!ccRowIsPresent)}
							/>
						</div>}
				</div>
			}
			{
				contactInputType === "select" &&
				<>
					<Select
						multiple
						className="email-template-select"
						value={[...selectedContacts.map(c => c.email), "placeholder"]}
						onChange={e => setSelectedContacts(contacts.filter(c => e.target.value.some(email => email === c.email)))}
						input={<Input id="select-multiple-checkbox" placeholder="Select contacts" />}
						renderValue={() => "Select contacts"}
						MenuProps={{
							PaperProps: {
								style: {
									height: contacts.length ? itemHeight * contacts.length + itemPaddingTop : 20,
									width: 250
								}
							}
						}}
					>
						{contacts.map(contact => <MenuItem key={contact.name} value={contact.email}>
							<Checkbox checked={Boolean(selectedContacts.find(c => c.email === contact.email))} />
							<ListItemText primary={contact.name} />
							</MenuItem>)}
					</Select>
					{selectedContacts.map(({ name, email }) => <div className="email-template-chip" key={name}>
						{name}
						<IconButton className="email-template-icon-button" key={name} onClick={() => setSelectedContacts(selectedContacts.filter(s => s.email !== email))}>
							<CloseIcon id="closeIcon" style={{ fontSize: 12 }} />
						</IconButton>
						</div>)}
				</>
			}
			{
				contactInputType === "input" &&
				<>
					{selectedContacts.map(({ email }) => <div className="email-template-chip" key={email}>
						{email}
						<IconButton className="email-template-icon-button" onClick={() => setSelectedContacts(selectedContacts.filter(s => s.email !== email))}>
							<CloseIcon id="closeIcon" style={{ fontSize: 12 }} />
						</IconButton>
						</div>)}
					<InputText
						value={emailInput}
						className={emailInputClass}
						onChange={e => setEmailInput(e.target.value)}
						onKeyPress={e => handleAddEmailEnterPress(e)}
					/>
					<ButtonText
						label="Add email"
						iconName="add"
						reverse
						className="email-template-add-email-buttontext"
						onClick={handleAddEmailButtonClick}
					/>
				</>
			}
		</div>
	);
};

export default RecipientRow;
